import type {
  CommonResponseListConceptResponse,
  GetConceptsParams,
  GetSubTopicsData,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'

import { adaptConcepts, adaptConceptTopics } from './adapters'
import type { Concept, ConceptTopic } from './schemas'

export type { GetConceptsParams }

export const getConcepts = async (
  params: GetConceptsParams,
  meta?: RequestMeta,
): Promise<Concept[]> => {
  const body = await httpClient().get<CommonResponseListConceptResponse>('/concepts', {
    params,
    meta,
  })
  return adaptConcepts(body.data) ?? []
}

// 서버가 CommonResponse 봉투 없이 목록을 그대로 보낸다.
export const getConceptTopics = async (
  conceptId: Concept['id'],
  meta?: RequestMeta,
): Promise<ConceptTopic[]> => {
  const body = await httpClient().get<GetSubTopicsData>(`/concepts/${conceptId}/sub-topics`, {
    meta,
  })
  return adaptConceptTopics(body) ?? []
}
